import axios from "axios";
import configuration from "@/utils/configuration";

export const scheudleService = {
  getScheduleFilterList() {
    return axios.get(`${configuration.backUrl}/schedules/filter-option`, {
      withCredentials: true,
    });
  },

  getAdminScheduleList(params) {
    return axios.get(`${configuration.backUrl}/schedules/management`, {
      params: params,
      withCredentials: true,
    });
  },
  getTodaySchedule() {
    return axios.get(`${configuration.backUrl}/schedules/management/today`, {
      withCredentials: true,
    });
  },

  // HOLIDAY MANAGEMENT
  getHolidaysList() {
    return axios.get(`${configuration.backUrl}/holidays`, {
      withCredentials: true,
    });
  },

    getHolidaysListAdmin() {
    return axios.get(`${configuration.backUrl}/schedules/management/holiday`, {
      withCredentials: true,
    });
  },

  getConflictHolidaysList() {
    return axios.get(`${configuration.backUrl}/schedules/management/holiday/conflict`, {
      withCredentials: true,
    });
  },
  postHoliday(payload) {
    return axios.post(`${configuration.backUrl}/holidays/management`, payload, {
      withCredentials: true,
    });
  },
  deleteHoliday(holidayId) {
    return axios.delete(`${configuration.backUrl}/holidays/management`, {
      params: { holiday_id: holidayId },
      withCredentials: true,
    });
  },
  patchHoliday(holidayId, payload) {
    return axios.patch(`${configuration.backUrl}/holidays/management`, payload, {
      params: { holiday_id: holidayId },
      withCredentials: true,
    });
  },
  getConfilctHoliday(date) {
    return axios.get(`${configuration.backUrl}/holidays/management/conflict`, {
      params:{date:date},
      withCredentials: true,
    });
  },

  // Admin Schedules Excel
  getScheduleExcelOption() {
    return axios.get(`${configuration.backUrl}/schedules/export/coach-checkin/option`, {
      withCredentials: true,
    });
  },
  getCoachCheckInExcel(payload) {
    return axios.post(`${configuration.backUrl}/schedules/export/coach-checkin`, payload, {
      responseType: "blob",
      withCredentials: true,
    });
  },

  // ------------------- Admin Timetable Management ---------------------
  getTimeTableList(params) {
    return axios.get(`${configuration.backUrl}/schedules/operator`, {
      withCredentials: true,
      params:params
    });
  },
  getTimeTableStudentList(params) {
    return axios.get(`${configuration.backUrl}/schedules/operator/students`,  {
      withCredentials: true,
      params:params
    });
  },
  postClassTimeTable(payload) {
    return axios.post(`${configuration.backUrl}/schedules/operator`,payload,{
      withCredentials: true,
    });
  },

};
